<div class="launchpad">
  <div *ngFor="let app of availableApps" class="checkbox-container">
    <mat-checkbox (change)="onSelectedChange($event, app)">
      {{app.name || app.title}}
    </mat-checkbox>
  </div>
  <div class="buttons">
    <button (click)="onSubmit()" [disabled]="selectedApps.size === 0" color="primary" mat-raised-button>
      Install selected apps
    </button>
    <button (click)="dialogRef.close()" mat-button type="button">Cancel</button>
  </div>
</div>
